import * as React from "react";
import {
  Box,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import useStyles from "./styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { format, addDays, isToday, isTomorrow, isYesterday } from "date-fns";
import api from "../../store/api";
import throttle from "lodash/throttle";
interface ErrorLog {
  id: number;
  createdOn: string;
  customer: string;
  location: string;
  bookingId: string;
  bookingNo: string;
  transferID: string;
  errorMessage: string;
}

interface ErrorLogProps {
  setLoading: any;
}
function ErrorLog(props: ErrorLogProps) {
  const { setLoading } = props;
  const classes = useStyles();
  const [selectedDay, setSelectedDay] = React.useState(
    format(new Date(), "yyyy-MM-dd")
  );

  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("datetime");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(10);
  const refOrder = React.useRef("desc");
  const refOrderBy = React.useRef("CreatedOn");
  const refSearchText = React.useRef("");
  const refPage = React.useRef(0);
  const refStatus = React.useRef(-1);
  const [errorLogList, seterrorLogList] = React.useState<ErrorLog[]>([]);
  const [recordCount, setRecordCount] = React.useState(0);
  const [Dates, setDates] = React.useState("");
  React.useEffect(() => {
    getAllError(
      refPage.current,
      refOrder.current,
      refOrderBy.current,
      selectedDay,
      selectedDay
    );
  }, []);

  const getPrettyDay = (selectedDay: string) => {
    if (isToday(new Date(selectedDay))) {
      return "Today";
    } else if (isTomorrow(new Date(selectedDay))) {
      return "Tomorrow";
    } else if (isYesterday(new Date(selectedDay))) {
      return "Yesterday";
    } else {
      return format(new Date(selectedDay), "dd/MM/yy");
    }
  };

  const headCells = [
    {
      id: "CreatedOn",
      numeric: false,
      disablePadding: true,
      label: "Date/Time",
      width: 160,
    },
    {
      id: "Customer",
      numeric: false,
      disablePadding: false,
      label: "Customer",
      width: 110,
    },
    {
      id: "Location",
      numeric: false,
      disablePadding: false,
      label: "Booking Location",
      width: 170,
    },
    {
      id: "BookingId",
      numeric: false,
      disablePadding: false,
      label: "Booking Id",
      width: 110,
    },
    {
      id: "TransferID",
      numeric: false,
      disablePadding: false,
      label: "Transfer",
      width: 50,
    },
    {
      id: "ErrorMessage",
      numeric: false,
      disablePadding: false,
      label: "Error",
      width: "auto",
    },
  ];

  const createSortHandler = (column: string) => {
    let order_str = "asc";
    if (orderBy === column) {
      if (order === "asc") {
        order_str = "desc";
      }
    }
    setOrder(order_str);
    setOrderBy(column);
    // api call
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
    // api call  };
  };
  const getAllError = React.useMemo(
    () =>
      throttle(
        async (
          updatePageNumber: any,
          sortOrder: any,
          sortColumn: any,
          startDay: any | null,
          endDay: any | null
        ): Promise<void> => {
          setLoading(true);
          const _res = await api.searchErrorLog(
            "pagenumber=" +
              ((updatePageNumber ? updatePageNumber : page)+1) +
              "&pagesize=10&sortcolumn=" +
              sortColumn +
              "&sortdirection=" +
              sortOrder +
              "&startdate=" +
              startDay +
              "&enddate=" +
              endDay
          );
          if (_res !== null && _res.data !== null && _res.data.model !== null) {
            seterrorLogList(_res.data.model);
            setRecordCount(_res.data.itemsCount);
          } else {
            seterrorLogList([]);
          }

          setLoading(false);
        },
        200
      ),
    []
  );
  // React.useMemo(()=>{
  //   getAllData()
  // },[Dates])
  React.useEffect(() => {
    getAllError(page, order, orderBy, selectedDay, selectedDay);
  }, [page]);
  React.useEffect(() => {
    if(page===0){
      getAllError(page, order, orderBy, selectedDay, selectedDay);
    }
    else{
      setPage(0);
    }
  }, [selectedDay]);
  const ViewClick = async (event: any, bookingid: any, transferid: any) => {
    if (bookingid) {
      setLoading(true)
      window.location.replace("/transferFullDetails/" + bookingid + "/" + transferid + "/0");
    }
  };
  return (
    <div className={classes.errorLog}>
      <div>
        <div className={"subHeader"}>
          <div className={"dateFilter"}>
            <IconButton
              className={"icon"}
              onClick={(x) => {
                setSelectedDay((prev) =>
                  format(addDays(new Date(prev), -1), "yyyy-MM-dd")
                );
              }}
            >
              <ArrowBackIosIcon />
            </IconButton>
            <div className={"date"}>{getPrettyDay(selectedDay)}</div>
            <IconButton
              className={"icon"}
              onClick={() => {
                setSelectedDay((prev) =>
                  format(addDays(new Date(prev), 1), "yyyy-MM-dd")
                );
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
        </div>
        <div className={"tableBox"}>
          <TableContainer>
            <Table size={"small"}>
              <TableHead>
                <TableRow>
                  {headCells.map((cell) => (
                    <TableCell
                      key={cell.id}
                      //width={cell.width}
                      style={{ minWidth: cell.width }}
                      align={cell.numeric ? "right" : "left"}
                      sortDirection={orderBy === cell.id ? "asc" : false}
                    >
                      <TableSortLabel
                        active={orderBy === cell.id}
                        direction={
                          orderBy === cell.id
                            ? order === "asc"
                              ? "asc"
                              : "desc"
                            : undefined
                        }
                        onClick={() => createSortHandler(cell.id)}
                      >
                        {cell.label}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {errorLogList.length > 0 ? (
                  errorLogList.map((row) => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row">
                          {format(
                            new Date(row.createdOn),
                            "dd/MM/yyyy HH:mm:ss"
                          )}
                        </TableCell>
                        <TableCell align="left">{row.customer}</TableCell>
                        <TableCell align="left">{row.location}</TableCell>
                        <TableCell align="left">{row.bookingNo}</TableCell>
                        <TableCell align="left">
                          <Box
                            style={{
                              alignSelf: "flex-end",
                              //marginRight: 30,
                              cursor: "pointer",
                              color: "#02489D",
                            }}
                            onClick={(event: any) =>
                              ViewClick(event, row.bookingId, row.transferID)
                            }
                          >
                            View
                          </Box>
                        </TableCell>
                        <TableCell align="left" style={{ maxWidth: 600 }}>
                          {row.errorMessage}
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10]}
            component="div"
            page={page}
            count={recordCount}
            rowsPerPage={rowsPerPage}
            onChangePage={handleChangePage}
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(ErrorLog);
